<template>
<footer class="footer">
	<div class="footer__counts">
		<div class="footer__count">
			<div class="footer__count-label">Всего игроков</div>
			<div class="footer__count-value" id="statsUsers">{{ allUsers }}</div>
		</div>
		<div class="footer__count">
			<div class="footer__count-label">Игроков онлайн</div>
			<div class="footer__count-value" id="statsOnline">{{ onlineUsers }}</div>
		</div>
		<div class="footer__count">
			<div class="footer__count-label">Сыграно игр</div>
			<div class="footer__count-value" id="statsGames">{{ allGames }}</div>
		</div>
		<div class="footer__count">
			<div class="footer__count-label">Выиграно сегодня</div>
			<div class="footer__count-value" id="statsWins">{{ todayWin }}</div>
		</div>
	</div>
	<div class="footer__nav">
		<router-link class="footer__nav-item" :to="{name: 'history'}">Выплаты</router-link>
		<a class="footer__nav-item" :href="$root.$link.reviews" target="_blank">Отзывы</a>
		<router-link class="footer__nav-item" :to="{name: 'contacts'}">Контакты</router-link>
		<router-link class="footer__nav-item" :to="{name: 'leaderboard'}">Топ игроков</router-link>
	</div>
	<div class="footer__logos">
		<a class="footer__logo" href="https://licensing.gaming-curacao.info/validator/?lh=2dgs5a44s863154459d57cbra1123dd2&rlh=fs2241e8ed7c785g5e12b88433gbf518" target="_blank">
			<img class="footer__logo-img" :src="gcLogoSrc" alt="GAMING CURACAO LICENSEE CLICK FOR MORE INFORMATION">
		</a>

		<div class="footer__logo">
			<img class="footer__logo-img footer__logo-img--bx" src="/images/Logo-gray.svg" alt="BOOM-X">
			<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.0001 34.9201C27.3447 34.9201 34.9201 27.3447 34.9201 18.0001C34.9201 8.65542 27.3447 1.08008 18.0001 1.08008C8.65542 1.08008 1.08008 8.65542 1.08008 18.0001C1.08008 27.3447 8.65542 34.9201 18.0001 34.9201Z" stroke="#FF6364" stroke-width="2"></path><path d="M10.1621 14.8881H8.2959V13.3848H11.9247V23.04H10.1621V14.8881ZM17.2425 23.1955C16.5599 23.1955 15.9594 23.0659 15.441 22.8067C14.9226 22.5388 14.5209 22.1846 14.2358 21.744C13.9506 21.2947 13.8081 20.7979 13.8081 20.2536C13.8081 19.7265 13.929 19.2643 14.171 18.8668C14.4215 18.4694 14.7801 18.1497 15.2466 17.9078C14.9183 17.7091 14.6591 17.4283 14.469 17.0654C14.2876 16.6939 14.1969 16.2921 14.1969 15.8601C14.1969 15.359 14.3265 14.9097 14.5857 14.5123C14.8449 14.1148 15.2034 13.8038 15.6614 13.5792C16.1279 13.3459 16.655 13.2292 17.2425 13.2292C17.8214 13.2292 18.3398 13.3416 18.7977 13.5662C19.2642 13.7908 19.6271 14.1062 19.8863 14.5123C20.1455 14.9097 20.2751 15.359 20.2751 15.8601C20.2751 16.2835 20.1844 16.6766 20.003 17.0395C19.8215 17.4024 19.5666 17.6918 19.2383 17.9078C19.7049 18.1584 20.0591 18.4824 20.301 18.8798C20.5516 19.2772 20.6769 19.7395 20.6769 20.2665C20.6769 20.8022 20.5343 21.2947 20.2492 21.744C19.9641 22.1846 19.558 22.5388 19.031 22.8067C18.5126 23.0659 17.9164 23.1955 17.2425 23.1955ZM15.5836 20.2017C15.5836 20.651 15.7348 21.0139 16.0372 21.2904C16.3396 21.5668 16.7414 21.7051 17.2425 21.7051C17.7436 21.7051 18.1454 21.5668 18.4478 21.2904C18.7588 21.0139 18.9143 20.651 18.9143 20.2017C18.9143 19.7524 18.7588 19.3939 18.4478 19.126C18.1454 18.8496 17.7436 18.7113 17.2425 18.7113C16.7414 18.7113 16.3396 18.8496 16.0372 19.126C15.7348 19.3939 15.5836 19.7524 15.5836 20.2017ZM15.9594 15.9638C15.9594 16.3267 16.0761 16.6291 16.3094 16.871C16.5513 17.1043 16.8623 17.2209 17.2425 17.2209C17.614 17.2209 17.9164 17.1043 18.1497 16.871C18.3916 16.6291 18.5126 16.3267 18.5126 15.9638C18.5126 15.6009 18.3916 15.3028 18.1497 15.0696C17.9164 14.8363 17.614 14.7196 17.2425 14.7196C16.8623 14.7196 16.5513 14.8363 16.3094 15.0696C16.0761 15.3028 15.9594 15.6009 15.9594 15.9638Z" fill="#FF6364"></path><path d="M25.151 18.3657H22.6367V16.9012H25.151V14.3999H26.6154V16.9012H29.1167V18.3657H26.6154V20.8799H25.151V18.3657Z" fill="#FF6364"></path></svg>
		</div>
	</div>
	<div class="footer__bottom">
		<div class="footer__license-text">This website is owned and operated by {{ $root.$company.name }}, a company registered and established under the laws of {{ $root.$company.city }}, with registration number {{ $root.$company.number }}, with registered address  {{ $root.$company.address }}, {{ $root.$company.city }}.</div>
		<div class="footer__links">
			<router-link class="footer__link" :to="{name: 'terms'}">Terms and Conditions</router-link>
			<router-link class="footer__link" :to="{name: 'KycPolicy'}">KYC Policy</router-link>
			<router-link class="footer__link" :to="{name: 'AmlPolicy'}">AML Policy</router-link>
			<a class="footer__link" :href="$root.$link.support"  target="_blank">Support</a>
			<router-link class="footer__link" :to="{name: 'ResponsibleGambling'}">Responsible Gambling</router-link>
		</div>
		<div class="footer__copy">© {{ new Date().getFullYear() }} BOOM-X. ALL RIGHTS RESERVED</div>
	</div>
</footer>
</template>
<script>
	export default {
		data() {
			return {
				allUsers: 0,
				allGames: 0,
				todayWin: 0,
				onlineUsers: 0,
				gcLogoSrc: '/assets/boomx/images/gc-logo.png',
			}
		},
		sockets: {
			stats: function (stats) {
				this.$root.updateOdometer('statsUsers', stats.users, this.allUsers);
				this.allUsers = stats.users;

				this.$root.updateOdometer('statsGames', stats.bets, this.allGames);
				this.allGames = stats.bets;

				this.$root.updateOdometer('statsWins', stats.amount, this.todayWin);
				this.todayWin = stats.amount;
			},

			online: function (count) {
				this.$root.updateOdometer('statsOnline', count, this.onlineUsers);
				this.onlineUsers = count;
			},
		}
	}
</script>